<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const currentYear = computed(() => new Date().getFullYear())

const menuItems = [
  { name: '首  页', path: '/' },
  { name: '下单须知', path: '/xiadanxuzhi' },
  { name: '新闻资讯', path: '/xinwenzixun' },
  { name: '服务支持', path: '/fuwuzhichi' },
  { name: '关于我们', path: '/guanyuwomen' }
]

const isActive = (path: string) => {
  if (path === '/') return route.path === '/'
  return route.path.startsWith(path)
}

const footerMenus = [
  { title: '关于鼎骁', items: ['关于鼎骁', '合作企业', '荣誉资质'] },
  { title: '新闻资讯', items: ['企业新闻', '产品行情', '通知公告'] },
  { title: '技术支持', items: ['服务政策', '疑难解答', '资料下载'] },
  { title: '联系我们', items: ['联系我们', '招商介绍', '诚聘英才'] }
]
</script>

<template>
  <div class="homepage">
    <!-- Header: Logo + 公司名 -->
    <div class="header-top">
      <div class="website-container">
        <div class="logo-area">
          <router-link to="/" class="logo-img">
            <img src="/images/CompanyLogo.svg" alt="鼎骁科技" />
          </router-link>
          <div class="company-name">
            <p class="name-cn">深圳市鼎骁科技有限公司</p>
            <p class="name-en">ShenZhen DingXiao Technology Co.,Ltd.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 导航菜单 -->
    <div class="nav-bar">
      <div class="website-container">
        <nav class="nav-list">
          <router-link
            v-for="item in menuItems"
            :key="item.path"
            :to="item.path"
            :class="['nav-item', { active: isActive(item.path) }]"
          >
            {{ item.name }}
          </router-link>
        </nav>
      </div>
    </div>

    <!-- Banner -->
    <div class="banner-section">
      <div class="website-container">
        <img src="/images/banner.jpg" alt="" class="banner-img" />
      </div>
    </div>

    <!-- 页面内容（由 router-view 渲染） -->
    <router-view></router-view>

    <!-- 底部菜单 -->
    <div class="footer-menu-section">
      <div class="website-container">
        <div class="footer-menu-inner">
          <div class="footer-menu-content">
            <dl v-for="menu in footerMenus" :key="menu.title" class="footer-dl">
              <dt>{{ menu.title }}</dt>
              <dd v-for="item in menu.items" :key="item">{{ item }}</dd>
            </dl>
            <div class="qr-code">
              <div class="qr-label text-center">
                官方公众号
                <img class="qr-img" src="/images/dingxiaotechWechart.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <footer class="footer-contact">
      <div class="website-container">
        <p class="text-center">
          <br />
          Tel:(+86)755-27782313 Fax:(+86)755-23016247<br />
          地址:广东省深圳市宝安区西乡街道宝安大道3073号德信文创园B座302 (坪洲地铁B出口直行400米)
          <br />
          &copy;2015-{{ currentYear }}
          <router-link to="/">深圳市鼎骁科技有限公司</router-link> 版权所有 &nbsp;|
          <a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备17000488号-3</a>&nbsp;|
          <a target="_blank" title="51la网站统计" href="https://v6.51.la/land/LASU8fEl3e67hXL3"><img src="https://sdk.51.la/icon/3-1.png" style="display:inline-block;vertical-align:middle;"></a>
        </p>
      </div>
    </footer>
  </div>
</template>

<style src="@/assets/css/website.css"></style>
